import { useEffect, useState } from "react";
import axios from "axios";
import { useAuthContext } from "../../hooks/useAuthContext";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import "./Bookings.css";
import BigCalender from "./BigCalender";
import SmallCalender from "./SmallCalender";
import { ArrowLeftCircle, ArrowRightCircle } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

export default function Bookings() {
  const [isLoading, setIsLoading] = useState(true);
  const { user, dispatch } = useAuthContext();
  const [bookings, setBookings] = useState([]);
  const navi = useNavigate();
  const [calPos1, setCalPos1] = useState(null);
  const [calPos2, setCalPos2] = useState([]);
  const [calPos3, setCalPos3] = useState([]);
  const [calPos4, setCalPos4] = useState([]);
  const [calPos5, setCalPos5] = useState([]);
  const [calPos6, setCalPos6] = useState([]);
  const [calPos7, setCalPos7] = useState([]);
  const [calPos8, setCalPos8] = useState([]);
  const [calPos9, setCalPos9] = useState([]);
  const [calPos10, setCalPos10] = useState([]);
  const [calPos11, setCalPos11] = useState([]);
  const [calPos12, setCalPos12] = useState([]);
  const [calPos13, setCalPos13] = useState([]);
  const [calPos14, setCalPos14] = useState([]);
  const [calPos15, setCalPos15] = useState([]);
  const [calPos16, setCalPos16] = useState([]);
  const [calPos17, setCalPos17] = useState([]);
  const [calPos18, setCalPos18] = useState([]);
  const [calPos19, setCalPos19] = useState([]);
  const [calPos20, setCalPos20] = useState([]);
  const [calPos21, setCalPos21] = useState([]);
  const [calPos22, setCalPos22] = useState([]);
  const [calPos23, setCalPos23] = useState([]);
  const [calPos24, setCalPos24] = useState([]);
  const [calPos25, setCalPos25] = useState([]);
  const [calPos26, setCalPos26] = useState([]);
  const [calPos27, setCalPos27] = useState([]);
  const [calPos28, setCalPos28] = useState([]);
  const [calPos29, setCalPos29] = useState([]);
  const [calPos30, setCalPos30] = useState([]);
  const [calPos31, setCalPos31] = useState([]);
  const [calPos32, setCalPos32] = useState([]);
  const [calPos33, setCalPos33] = useState([]);
  const [calPos34, setCalPos34] = useState([]);
  const [calPos35, setCalPos35] = useState([]);
  const [calPos36, setCalPos36] = useState([]);
  const [calPos37, setCalPos37] = useState([]);
  const [calPos38, setCalPos38] = useState([]);
  const [calPos39, setCalPos39] = useState([]);
  const [calPos40, setCalPos40] = useState([]);
  const [calPos41, setCalPos41] = useState([]);
  const [calPos42, setCalPos42] = useState([]);
  const [bookingDate1, setBookingDate1] = useState(null);
  const [bookingDate2, setBookingDate2] = useState(null);
  const [bookingDate3, setBookingDate3] = useState(null);
  const [bookingDate4, setBookingDate4] = useState(null);
  const [bookingDate5, setBookingDate5] = useState(null);
  const [bookingDate6, setBookingDate6] = useState(null);
  const [bookingDate7, setBookingDate7] = useState(null);
  const [bookingDate8, setBookingDate8] = useState(null);
  const [bookingDate9, setBookingDate9] = useState(null);
  const [bookingDate10, setBookingDate10] = useState(null);
  const [bookingDate11, setBookingDate11] = useState(null);
  const [bookingDate12, setBookingDate12] = useState(null);
  const [bookingDate13, setBookingDate13] = useState(null);
  const [bookingDate14, setBookingDate14] = useState(null);
  const [bookingDate15, setBookingDate15] = useState(null);
  const [bookingDate16, setBookingDate16] = useState(null);
  const [bookingDate17, setBookingDate17] = useState(null);
  const [bookingDate18, setBookingDate18] = useState(null);
  const [bookingDate19, setBookingDate19] = useState(null);
  const [bookingDate20, setBookingDate20] = useState(null);
  const [bookingDate21, setBookingDate21] = useState(null);
  const [bookingDate22, setBookingDate22] = useState(null);
  const [bookingDate23, setBookingDate23] = useState(null);
  const [bookingDate24, setBookingDate24] = useState(null);
  const [bookingDate25, setBookingDate25] = useState(null);
  const [bookingDate26, setBookingDate26] = useState(null);
  const [bookingDate27, setBookingDate27] = useState(null);
  const [bookingDate28, setBookingDate28] = useState(null);
  const [bookingDate29, setBookingDate29] = useState(null);
  const [bookingDate30, setBookingDate30] = useState(null);
  const [bookingDate31, setBookingDate31] = useState(null);

  const [startingPostion, setStartingPostion] = useState(null);
  const [calenderDate, setCalendarDate] = useState(new Date());

  const handleAddMonth = () => {
    setCalendarDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setMonth(newDate.getMonth() + 1);
      return newDate;
    });
  };

  const handleSubtractMonth = () => {
    setCalendarDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setMonth(newDate.getMonth() - 1);
      return newDate;
    });
  };

  const firstDayName = new Date(
    calenderDate.getFullYear(),
    calenderDate.getMonth(),
    1
  ).toLocaleDateString("en-US", { weekday: "long" });

  useEffect(() => {
    switch (firstDayName) {
      case "Sunday":
        setStartingPostion(7);
        break;
      case "Monday":
        setStartingPostion(1);
        break;
      case "Tuesday":
        setStartingPostion(2);
        break;
      case "Wednesday":
        setStartingPostion(3);
        break;
      case "Thursday":
        setStartingPostion(4);
        break;
      case "Friday":
        setStartingPostion(5);
        break;
      case "Saturday":
        setStartingPostion(6);
        break;
      default:
        setStartingPostion(0);
    }
  }, [calenderDate, user]);

  useEffect(() => {
    setIsLoading(true);
    const daysInMonth = new Date(
      calenderDate.getFullYear(),
      calenderDate.getMonth() + 1,
      0
    ).getDate();

    const fillCalender = async () => {
      // Start by filling the calendar with the first day's position
      let calendarDays = new Array(35).fill(null); // Assuming a 35-day grid

      // Place each day in the correct position based on the starting day
      for (let i = 1; i <= daysInMonth; i++) {
        calendarDays[startingPostion + i - 1] = i; // Fill positions with day numbers
      }

      await setCalPos1([
        calendarDays[1],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[1]
        ),
      ]);
      await setCalPos2([
        calendarDays[2],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[2]
        ),
      ]);
      await setCalPos3([
        calendarDays[3],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[3]
        ),
      ]);
      await setCalPos4([
        calendarDays[4],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[4]
        ),
      ]);
      await setCalPos5([
        calendarDays[5],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[5]
        ),
      ]);
      await setCalPos6([
        calendarDays[6],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[6]
        ),
      ]);
      await setCalPos7([
        calendarDays[7],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[7]
        ),
      ]);
      await setCalPos8([
        calendarDays[8],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[8]
        ),
      ]);
      setCalPos9([
        calendarDays[9],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[9]
        ),
      ]);
      await setCalPos10([
        calendarDays[10],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[10]
        ),
      ]);
      await setCalPos11([
        calendarDays[11],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[11]
        ),
      ]);
      await setCalPos12([
        calendarDays[12],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[12]
        ),
      ]);
      await setCalPos13([
        calendarDays[13],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[13]
        ),
      ]);
      await setCalPos14([
        calendarDays[14],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[14]
        ),
      ]);
      await setCalPos15([
        calendarDays[15],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[15]
        ),
      ]);
      await setCalPos16([
        calendarDays[16],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[16]
        ),
      ]);
      await setCalPos17([
        calendarDays[17],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[17]
        ),
      ]);
      await setCalPos18([
        calendarDays[18],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[18]
        ),
      ]);
      await setCalPos19([
        calendarDays[19],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[19]
        ),
      ]);
      await setCalPos20([
        calendarDays[20],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[20]
        ),
      ]);
      await setCalPos21([
        calendarDays[21],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[21]
        ),
      ]);
      setCalPos22([
        calendarDays[22],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[22]
        ),
      ]);
      await setCalPos23([
        calendarDays[23],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[23]
        ),
      ]);
      await setCalPos24([
        calendarDays[24],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[24]
        ),
      ]);
      await setCalPos25([
        calendarDays[25],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[25]
        ),
      ]);
      await setCalPos26([
        calendarDays[26],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[26]
        ),
      ]);
      await setCalPos27([
        calendarDays[27],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[27]
        ),
      ]);
      await setCalPos28([
        calendarDays[28],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[28]
        ),
      ]);
      await setCalPos29([
        calendarDays[29],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[29]
        ),
      ]);
      await setCalPos30([
        calendarDays[30],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[30]
        ),
      ]);
      await setCalPos31([
        calendarDays[31],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[31]
        ),
      ]);
      await setCalPos32([
        calendarDays[32],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[32]
        ),
      ]);
      await setCalPos33([
        calendarDays[33],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[33]
        ),
      ]);
      await setCalPos34([
        calendarDays[34],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[34]
        ),
      ]);
      await setCalPos35([
        calendarDays[35],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[35]
        ),
      ]);
      await setCalPos36([
        calendarDays[36],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[36]
        ),
      ]);
      await setCalPos37([
        calendarDays[37],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[37]
        ),
      ]);
      await setCalPos38([
        calendarDays[38],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[38]
        ),
      ]);
      await setCalPos39([
        calendarDays[39],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[39]
        ),
      ]);
      await setCalPos40([
        calendarDays[40],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[40]
        ),
      ]);
      await setCalPos41([
        calendarDays[41],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[41]
        ),
      ]);
      await setCalPos42([
        calendarDays[42],
        bookings.filter(
          (booking) => new Date(booking.date).getDate() === calendarDays[42]
        ),
      ]);

      setBookingDate1(
        bookings.filter((booking) => new Date(booking.date).getDate() === 1)
      );
      setBookingDate2(
        bookings.filter((booking) => new Date(booking.date).getDate() === 2)
      );
      setBookingDate3(
        bookings.filter((booking) => new Date(booking.date).getDate() === 3)
      );
      setBookingDate4(
        bookings.filter((booking) => new Date(booking.date).getDate() === 4)
      );
      setBookingDate5(
        bookings.filter((booking) => new Date(booking.date).getDate() === 5)
      );
      setBookingDate6(
        bookings.filter((booking) => new Date(booking.date).getDate() === 6)
      );
      setBookingDate7(
        bookings.filter((booking) => new Date(booking.date).getDate() === 7)
      );
      setBookingDate8(
        bookings.filter((booking) => new Date(booking.date).getDate() === 8)
      );
      setBookingDate9(
        bookings.filter((booking) => new Date(booking.date).getDate() === 9)
      );
      setBookingDate10(
        bookings.filter((booking) => new Date(booking.date).getDate() === 10)
      );
      setBookingDate11(
        bookings.filter((booking) => new Date(booking.date).getDate() === 11)
      );
      setBookingDate12(
        bookings.filter((booking) => new Date(booking.date).getDate() === 12)
      );
      setBookingDate13(
        bookings.filter((booking) => new Date(booking.date).getDate() === 13)
      );
      setBookingDate14(
        bookings.filter((booking) => new Date(booking.date).getDate() === 14)
      );
      setBookingDate15(
        bookings.filter((booking) => new Date(booking.date).getDate() === 15)
      );
      setBookingDate16(
        bookings.filter((booking) => new Date(booking.date).getDate() === 16)
      );
      setBookingDate17(
        bookings.filter((booking) => new Date(booking.date).getDate() === 17)
      );
      setBookingDate18(
        bookings.filter((booking) => new Date(booking.date).getDate() === 18)
      );
      setBookingDate19(
        bookings.filter((booking) => new Date(booking.date).getDate() === 19)
      );
      setBookingDate20(
        bookings.filter((booking) => new Date(booking.date).getDate() === 20)
      );
      setBookingDate21(
        bookings.filter((booking) => new Date(booking.date).getDate() === 21)
      );
      setBookingDate22(
        bookings.filter((booking) => new Date(booking.date).getDate() === 22)
      );
      setBookingDate23(
        bookings.filter((booking) => new Date(booking.date).getDate() === 23)
      );
      setBookingDate24(
        bookings.filter((booking) => new Date(booking.date).getDate() === 24)
      );
      setBookingDate25(
        bookings.filter((booking) => new Date(booking.date).getDate() === 25)
      );
      setBookingDate26(
        bookings.filter((booking) => new Date(booking.date).getDate() === 26)
      );
      setBookingDate27(
        bookings.filter((booking) => new Date(booking.date).getDate() === 27)
      );
      setBookingDate28(
        bookings.filter((booking) => new Date(booking.date).getDate() === 28)
      );
      setBookingDate29(
        bookings.filter((booking) => new Date(booking.date).getDate() === 29)
      );
      setBookingDate30(
        bookings.filter((booking) => new Date(booking.date).getDate() === 30)
      );
      setBookingDate31(
        bookings.filter((booking) => new Date(booking.date).getDate() === 31)
      );
    };
    fillCalender();

    setIsLoading(false);
  }, [calenderDate, startingPostion, bookings, user]);

  const fetchData = async () => {
    try {
      setIsLoading(true);

      const bookingResponse = await axios.get(
        `${ApiConnectionString}/api/AllImBookedOnto?FromDateTime=${
          calenderDate.toISOString().split("T")[0]
        }`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setBookings(bookingResponse.data);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;
  
    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
  
        if (!user) {
          dispatch({ type: "LOGOUT" });
          navi("/");
        }
      }, 3000);
    }
  
    return () => clearTimeout(timeout); // Cleanup timeout if user changes
  }, [calenderDate, user]);

  if (isLoading || !user) {
    return (
      <div>
        <LoadingSpinner />;
      </div>
    );
  } else if(bookings) {
    return (
      <div className="container bg-white  pb-5 mb-5">
        <div className="blueBanner">
          <p className="fw-bold p-2">My Bookings</p>
        </div>

        <div className="lightBlueBanner">
          <p className="fontSize20 p-1 text-center">
            {calenderDate.toLocaleDateString("en-GB", {
              month: "long",
              year: "numeric",
            })}
          </p>
        </div>
        <div className="d-flex justify-content-between">
          <ArrowLeftCircle size={50} onClick={handleSubtractMonth} />
          <ArrowRightCircle size={50} onClick={handleAddMonth} />
        </div>

        {bookings?.length === 0 && (
          <p className="text-center">No bookings this month.</p>
        )}

        <div className="">
          <SmallCalender
            bookingDate1={bookingDate1}
            bookingDate2={bookingDate2}
            bookingDate3={bookingDate3}
            bookingDate4={bookingDate4}
            bookingDate5={bookingDate5}
            bookingDate6={bookingDate6}
            bookingDate7={bookingDate7}
            bookingDate8={bookingDate8}
            bookingDate9={bookingDate9}
            bookingDate10={bookingDate10}
            bookingDate11={bookingDate11}
            bookingDate12={bookingDate12}
            bookingDate13={bookingDate13}
            bookingDate14={bookingDate14}
            bookingDate15={bookingDate15}
            bookingDate16={bookingDate16}
            bookingDate17={bookingDate17}
            bookingDate18={bookingDate18}
            bookingDate19={bookingDate19}
            bookingDate20={bookingDate20}
            bookingDate21={bookingDate21}
            bookingDate22={bookingDate22}
            bookingDate23={bookingDate23}
            bookingDate24={bookingDate24}
            bookingDate25={bookingDate25}
            bookingDate26={bookingDate26}
            bookingDate27={bookingDate27}
            bookingDate28={bookingDate28}
            bookingDate29={bookingDate29}
            bookingDate30={bookingDate30}
            bookingDate31={bookingDate31}
            stringDate={calenderDate.toLocaleDateString("en-GB", {
              month: "long",
              year: "numeric",
            })}
          />
        </div>

        {/* <div className="small-calender">
          <SmallCalender
            bookingDate1={bookingDate1}
            bookingDate2={bookingDate2}
            bookingDate3={bookingDate3}
            bookingDate4={bookingDate4}
            bookingDate5={bookingDate5}
            bookingDate6={bookingDate6}
            bookingDate7={bookingDate7}
            bookingDate8={bookingDate8}
            bookingDate9={bookingDate9}
            bookingDate10={bookingDate10}
            bookingDate11={bookingDate11}
            bookingDate12={bookingDate12}
            bookingDate13={bookingDate13}
            bookingDate14={bookingDate14}
            bookingDate15={bookingDate15}
            bookingDate16={bookingDate16}
            bookingDate17={bookingDate17}
            bookingDate18={bookingDate18}
            bookingDate19={bookingDate19}
            bookingDate20={bookingDate20}
            bookingDate21={bookingDate21}
            bookingDate22={bookingDate22}
            bookingDate23={bookingDate23}
            bookingDate24={bookingDate24}
            bookingDate25={bookingDate25}
            bookingDate26={bookingDate26}
            bookingDate27={bookingDate27}
            bookingDate28={bookingDate28}
            bookingDate29={bookingDate29}
            bookingDate30={bookingDate30}
            bookingDate31={bookingDate31}
            stringDate={calenderDate.toLocaleDateString("en-GB", {
              month: "long",
              year: "numeric",
            })}
          />
        </div>
        <div className="big-calnder">
          <BigCalender
            calPos1={calPos1}
            calPos2={calPos2}
            calPos3={calPos3}
            calPos4={calPos4}
            calPos5={calPos5}
            calPos6={calPos6}
            calPos7={calPos7}
            calPos8={calPos8}
            calPos9={calPos9}
            calPos10={calPos10}
            calPos11={calPos11}
            calPos12={calPos12}
            calPos13={calPos13}
            calPos14={calPos14}
            calPos15={calPos15}
            calPos16={calPos16}
            calPos17={calPos17}
            calPos18={calPos18}
            calPos19={calPos19}
            calPos20={calPos20}
            calPos21={calPos21}
            calPos22={calPos22}
            calPos23={calPos23}
            calPos24={calPos24}
            calPos25={calPos25}
            calPos26={calPos26}
            calPos27={calPos27}
            calPos28={calPos28}
            calPos29={calPos29}
            calPos30={calPos30}
            calPos31={calPos31}
            calPos32={calPos32}
            calPos33={calPos33}
            calPos34={calPos34}
            calPos35={calPos35}
            calPos36={calPos36}
            calPos37={calPos37}
            calPos38={calPos38}
            calPos39={calPos39}
            calPos40={calPos40}
            calPos41={calPos41}
            calPos42={calPos42}
          />
        </div> */}
      </div>
    );
  }
}
